import React from 'react';

import { Stack, Typography } from '@mui/material';

import { definitions } from '@luxuryescapes/contract-svc-promo';

import PromoItemField from '~/components/PromoV3/PromoItemField';

import { getPromoProductDisplayName } from '~/services/PromoService';

import currencyFormatter from '~/utils/currencyFormatter';

type PromoResponseItemProps = {
  item: definitions['Discount Response']['promo']['items'][0];
  currencyCode: string;
  meta: definitions['PromoMeta'];
};

function PromoResponseItem({ item, currencyCode, meta }: PromoResponseItemProps) {
  const hasDiscount = item.discountAmount > 0;
  const isLuxPlusPrice = item.luxPlusPrice > 0 && item.luxPlusPrice < item.discountableTotal;
  return (
    <Stack direction="column" gap={1}>
      <Typography>
        {hasDiscount && (
          <Typography component="span" color={isLuxPlusPrice ? 'blue' : 'text.primary'}>
            {currencyFormatter(currencyCode, item.discountableTotal - item.discountAmount)}
          </Typography>
        )}
        <Typography
          sx={{
            textDecoration: hasDiscount ? 'line-through' : '',
          }}
          component="span"
          color={isLuxPlusPrice ? 'blue' : 'text.primary'}
        >
          {currencyFormatter(currencyCode, item.discountableTotal)}
        </Typography>
        {hasDiscount && (
          <Typography color="green" component="span">
            ({currencyFormatter(currencyCode, item.discountAmount)})
          </Typography>
        )}
      </Typography>
      <PromoItemField
        title="Product Type"
        field="productType"
        categoryBK={item.categoryBK}
        value={meta && getPromoProductDisplayName(meta.promo_product_types, item.categoryBK, item.subCategoryBK)}
      />
    </Stack>
  );
}

export { PromoResponseItem };
